const modules = {
	versionDisplay: "versionDisplay",
	accordionComponent: "accordion",
	applicationApplyComponent: "applicationApply",
	breadcrumbComponent: "breadcrumb",
	callbackButtonComponent: "callback-button",
	checkboxComponent: "checkbox",
	datepickerComponent: "datepicker",
	// faqComponent: "faq",
	fileUploadComponent: "file-upload",
	formComponent: "form",
	formRepeatable: "form-repeatable",
	galleryComponent: "gallery",
	handlePagination: "handlePagination",
	headerComponent: "header",
	headerSelectComponent: "header-select",
	inputFieldComponent: "input",
	occupationalFieldsComponent: "occupational-fields",
	mapComponent: "map",
	newsCategoriesComponent: "news-categories",
	newsListComponent: "news-list",
	lazyloadComponent: "lazyloadComponent",
	lightboxComponent: "lightboxComponent",
	multiselectComponent: "multiselect",
	overlayComponent: "overlay",
	radiofieldComponent: "radiofield",
	selectComponent: "select",
	sliderContainerComponent: "sliderContainer",
	tabsComponent: "tabs",
	tooltipComponent: "tooltip",
	youtubeVideoComponent: "youtube-video",
	jobSearchComponent: "job-search",
	contactPersonsComponent: "contact-persons",
}

const loadedModules = {}

class DynamicModuleLoader {
	/**
	 * get the list of dynamic Modules
	 * @returns object
	 */
	get modules() {
		return modules
	}

	/**
	 * use webpack dynamic imports
	 * @param componentName {string}
	 * @param callback {function}
	 * @private
	 */
	_import(componentName, callback) {
		if (typeof componentName === "string" && typeof callback === "function") {
			let modulePromise

			switch (componentName) {
				case modules.versionDisplay:
					modulePromise = import(/* webpackChunkName: "versionDisplay" */ "../components/VersionDisplay")
					break
				case modules.accordionComponent:
					modulePromise = import(/* webpackChunkName: "accordion" */ "../../components/accordion/accordion")
					break
				case modules.applicationApplyComponent:
					modulePromise = import(
						/* webpackChunkName: "application-apply" */ "../../components/application-apply/application-apply"
					)
					break
				case modules.breadcrumbComponent:
					modulePromise = import(
						/* webpackChunkName: "breadcrumb" */ "../../components/breadcrumb/breadcrumb"
					)
					break
				case modules.callbackButtonComponent:
					modulePromise = import(
						/* webpackChunkName: "callback-button" */ "../../components/callback-button/callback-button"
					)
					break
				case modules.checkboxComponent:
					modulePromise = import(/* webpackChunkName: "checkbox" */ "../../components/checkbox/checkbox")
					break
				case modules.datepickerComponent:
					modulePromise = import(
						/* webpackChunkName: "datepicker" */ "../../components/datepicker/datepicker"
					)
					break
				// case modules.faqComponent:
				// 	modulePromise = import( /* webpackChunkName: "faq" */ '../../components/faq/faq')
				// 	break
				case modules.fileUploadComponent:
					modulePromise = import(
						/* webpackChunkName: "fileUpload" */ "../../components/file-upload/file-upload"
					)
					break
				case modules.formComponent:
					modulePromise = import(/* webpackChunkName: "form" */ "../../components/form/form")
					break
				case modules.formRepeatable:
					modulePromise = import(
						/* webpackChunkName: "form-repeatable" */ "../../components/form-repeatable/form-repeatable"
					)
					break
				case modules.galleryComponent:
					modulePromise = import(/* webpackChunkName: "gallery" */ "../../components/gallery/gallery")
					break
				case modules.handlePagination:
					modulePromise = import(/* webpackChunkName: "handle-pagination" */ "../utils/HandlePagination")
					break
				case modules.headerComponent:
					modulePromise = import(/* webpackChunkName: "header" */ "../../components/header/header")
					break
				case modules.headerSelectComponent:
					modulePromise = import(
						/* webpackChunkName: "header-select" */ "../../components/header-select/header-select"
					)
					break
				case modules.inputFieldComponent:
					modulePromise = import(
						/* webpackChunkName: "input-field" */ "../../components/inputfield/inputfield"
					)
					break
				case modules.mapComponent:
					modulePromise = import(/* webpackChunkName: "map" */ "../../components/map/map")
					break
				case modules.newsCategoriesComponent:
					modulePromise = import(
						/* webpackChunkName: "news-categories" */ "../../components/news-categories/news-categories"
					)
					break
				case modules.newsListComponent:
					modulePromise = import(/* webpackChunkName: "news-list" */ "../../components/news-list/news-list")
					break
				case modules.lazyloadComponent:
					modulePromise = import(/* webpackChunkName: "lazyLoad" */ "../components/LazyLoad")
					break
				case modules.lightboxComponent:
					modulePromise = import(/* webpackChunkName: "lightbox" */ "../components/Lightbox")
					break
				case modules.multiselectComponent:
					modulePromise = import(
						/* webpackChunkName: "multiselect" */ "../../components/multiselect/multiselect"
					)
					break
				case modules.overlayComponent:
					modulePromise = import(/* webpackChunkName: "overlay" */ "../../components/overlay/overlay")
					break
				case modules.radiofieldComponent:
					modulePromise = import(
						/* webpackChunkName: "radiofield" */ "../../components/radiofield/radiofield"
					)
					break
				case modules.selectComponent:
					modulePromise = import(/* webpackChunkName: "select" */ "../../components/select/select")
					break
				case modules.sliderContainerComponent:
					modulePromise = import(
						/* webpackChunkName: "slider-container" */ "../../components/slider-container/slider-container"
					)
					break
				case modules.tabsComponent:
					modulePromise = import(/* webpackChunkName: "tabs" */ "../../components/tabs/tabs")
					break
				case modules.tooltipComponent:
					modulePromise = import(/* webpackChunkName: "tooltip" */ "../../components/tooltip/tooltip")
					break
				case modules.youtubeVideoComponent:
					modulePromise = import(
						/* webpackChunkName: "youtube-video" */ "../../components/youtube-video/youtube-video"
					)
					break
				case modules.occupationalFieldsComponent:
					modulePromise = import(
						/* webpackChunkName: "occupational-fields" */ "../../components/occupational-fields/occupational-fields"
					)
					break
				case modules.jobSearchComponent:
					modulePromise = import(
						/* webpackChunkName: "job-search" */ "../../components/job-search/job-search"
					)
					break
				case modules.contactPersonsComponent:
					modulePromise = import(
						/* webpackChunkName: "contact-persons" */ "../../components/contact-persons/contact-persons"
					)
					break
				default:
					// eslint-disable-next-line no-console
					console.warn("Module not found")
					break
			}

			modulePromise.then((component) => {
				callback(component.default)
			})
		}
	}

	/**
	 * Dynamically Module Loader
	 * @param condition {boolean}
	 * @param componentName {string}
	 * @param onLoadComponent {function}
	 */
	load(condition, componentName, onLoadComponent = undefined) {
		if (condition) {
			if (!loadedModules[componentName]) {
				this._import(componentName, (Component) => {
					if (typeof onLoadComponent === "function") {
						onLoadComponent(Component)
					} else {
						new Component()
					}
					loadedModules[componentName] = Component
				})
			} else {
				if (typeof onLoadComponent === "function") {
					onLoadComponent(loadedModules[componentName])
				}
			}
		}
	}
}

export default new DynamicModuleLoader()
